<FormModal
  model={billingCustomer}
  modelName="customer"
  humanModelName="Rechnungsadresse"
  humanModelNamePronoun="die"
  createAction={false}
  updateAction={updateCustomer}
  deleteAction={false}
  form={Form}
  {open}
  data-billing-address-modal
  on:success
  on:close
/>

<script lang="ts">
  import type { Customer } from '../../models'
  import FormModal from '../../shared/FormModal.svelte'
  import { updateCustomer } from '../../persistence'
  import Form from './Form.svelte'

  export let customer: Customer
  export let open = true

  const keys = ['name', 'industry', 'street', 'postbox', 'zip_code', 'city', 'country']
  $: billingCustomer = open
    ? keys.reduce<Customer>((obj, key) => ({ ...obj, [key]: customer[key] }), { id: customer.id })
    : undefined
</script>
